import styled, { css } from "styled-components";
import { IWrapperProps } from "./interfaces";
export const StyledTooltip = styled.div`
    position: absolute;
    top: calc(100% + 2px);
    left: 50%;
    transform: translateX(-50%) translateZ(0);
    background-color: ${p => p.theme.c.boost};
    color: ${p => p.theme.c.whiteOnActive};
    font-weight: 300;
    font-size: 15px;

    border-radius: 6px;
    padding: 6px 8px;
    z-index: 10;
    opacity: 0;
    pointer-events: none;
    transition: 300ms;
    white-space: nowrap;
    font-variant: normal;
    box-shadow: 0 0 4px 0 ${p => p.theme.c.blackShadow3};

    &:before {
        content: "";
        width: 10px;
        height: 10px;
        transform: rotate(45deg);
        position: absolute;
        border-radius: 2px;
        top: -4px;
        left: calc(50% - 4px);
        background-color: ${p => p.theme.c.boost};
    }

    ${p =>
        p.theme.xs(css`
            display: none;
        `)}

    @media screen and (pointer: coarse) {
        display: none;
    }

    &.Light {
        background-color: ${p => p.theme.mode === "dark" ? p.theme.c.cardBackground : p.theme.c.snow};
        color: ${p => p.theme.mode === "dark" ? p.theme.c.whiteOnActive : p.theme.c.dark};
        &:before {
            background-color: ${p => p.theme.mode === "dark" ? p.theme.c.cardBackground : p.theme.c.snow};
        }
    }

    &.Grey {
        background-color: ${p => p.theme.mode === "dark" ? p.theme.c.greyA : p.theme.c.disabled};
        color: ${p => p.theme.c.black};
        &:before {
            background-color: ${p => p.theme.mode === "dark" ? p.theme.c.greyA : p.theme.c.disabled};
        }
    }

    &.Dark {
        background-color: ${p => p.theme.c.dark};
        &:before {
            background-color: ${p => p.theme.c.dark};
        }
    }

    &.Disabled {
        display: none;
    }

    &.Flipped {
        bottom: calc(100% + 12px);
        top: auto;

        &:before {
            transform: rotate(-135deg);
            bottom: -4px;
            top: auto;
        }
    }
`;

export const Wrapper = styled.div<IWrapperProps>`
    display: inline-block;
    position: relative;

    .AlwaysDisplay {
        opacity: 1;
    }
    &:hover {
        div {
            opacity: 1;
        }
    }

    a {
        display: block;
    }

    ${p =>
        p.hideOnMobile &&
        css`
            display: none;
        `}
`;
